import { Component } from '@angular/core';

@Component({
  selector: 'app-reports-page',
  templateUrl: './reports-page.component.html',
  styleUrl: './reports-page.component.scss'
})
export class ReportsPageComponent {

  reportTabs: { name: string, icon: string, slug: 'warehouse' | 'single-warehouse' | 'sensor' | 'building' | 'alert' | 'env-summary' | 'coldroom' }[] = [
    { name: 'Warehouse Report', icon: "assets/icons/building-03.png", slug: "warehouse" },
    // { name: 'Single Warehouse Report', icon: faWarehouse, slug: "single-warehouse" },
    { name: 'Environment Report', icon: "assets/icons/tree-02.png", slug: "env-summary" },
    { name: 'Sensor Performance Report', icon: "assets/icons/internet-antenna-01.png", slug: "sensor" },
    { name: 'Zone Analysis Report', icon: "assets/icons/entering-geo-fence.png", slug: "building" },
    { name: 'Alert Report', icon: "assets/icons/notification-02.png", slug: "alert" },
    { name: 'Coldroom Report', icon: "assets/icons/building-03.png", slug: "coldroom" },
  ]
  activeReportTab: 'warehouse' | 'single-warehouse' | 'sensor' | 'alert' | 'building' | 'env-summary' | 'coldroom' = 'warehouse';

}
